var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.625,
    fill: "#1E1C56",
    stroke: "white",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 8C12.7744 8 10.1504 10.6712 10.1504 13.9545C10.1504 15.7911 11.0793 18.0203 12.9113 20.5801C14.252 22.4535 15.5731 23.7895 15.6287 23.8455C15.7309 23.9484 15.8653 24 15.9999 24C16.1306 24 16.2614 23.9513 16.3628 23.8537C16.4185 23.8 17.743 22.518 19.0862 20.6705C20.9197 18.1486 21.8494 15.889 21.8494 13.9545C21.8493 10.6712 19.2252 8 15.9998 8ZM15.9998 16.5252C14.423 16.5252 13.1401 15.2423 13.1401 13.6655C13.1401 12.0886 14.423 10.8058 15.9998 10.8058C17.5767 10.8058 18.8596 12.0886 18.8596 13.6655C18.8596 15.2423 17.5767 16.5252 15.9998 16.5252Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/IconMap.8de2737dbce9d63e87052d5a7f17ff9d.svg";
export { ForwardRef as ReactComponent };